export const REMOVE_SHOPS = 'REMOVE_SHOPS'
export const SET_SHOP_STATE = 'SET_SHOP_STATE'

export enum SHOP_RESPONSE {
	CREATED = 'CREATED',
	EDITED = 'EDITED',
	REMOVED = 'REMOVED'
}
